import PatientInsurance, { mapPatientInsuranceFromApi, mapPatientInsuranceToApi } from '../models/PatientInsurance'
import HashReturnObject from '../models/HashReturnObject';
import { getBaseAPI } from "../environments/Environments";
import { StateModel } from '../models/StateModel';
import { mapSessionData, SessionModel } from '../models/Session';
import { apiFetch } from './ServiceHelper';
import ErrorService from "./ErrorService";

const PatientInsuranceService = {
    getPatientInsurance: (state: StateModel): Promise<HashReturnObject<PatientInsurance>> => {
        return new Promise( async (resolve, reject) => {
            const url = await getBaseAPI() + '/api/v1/Patient/getPatient_Insurance';
            // const url = 'https://localhost:5001/api/v1/Patient/getPatient_Insurance';

            apiFetch(url, {
                method: 'POST',
                body: JSON.stringify(mapSessionData(state.session)),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((result) => Promise.resolve(result))
                .then((hashReturnObject: HashReturnObject<PatientInsurance>) => {
                 
                    if (hashReturnObject.hasOwnProperty('error')) {
                        ErrorService.showErrorAlert('Oops! Something went wrong. Please try again later. If the issue persists, please contact our support team for assistance.', hashReturnObject);
                    }
                        resolve({
                            data: [ mapPatientInsuranceFromApi(hashReturnObject.data[0]) ],
                            hash: hashReturnObject.hash,
                            sessionId: hashReturnObject.sessionId
                        });
                })
                .catch((e) => {
                    console.log('Patient Insurance Serice error');
                    reject(e);
                });
        });
    },
    savePatientInsurance: (patientInsurance: PatientInsurance, session: SessionModel): Promise<PatientInsurance> => {
        return new Promise(async (resolve, reject) => {
            // const url = 'https://localhost:5001/api/v1/Patient/savePatient_Insurance';

            const url = await getBaseAPI() + '/api/v1/Patient/savePatient_Insurance';
            var json = JSON.stringify(mapPatientInsuranceToApi(patientInsurance, session))
            apiFetch(url, {
              method: 'POST',
              body: JSON.stringify(mapPatientInsuranceToApi(patientInsurance, session)),
              headers: {
                'Content-Type': 'application/json'
            }
            })
                .then((result) => Promise.resolve(result))
                .then((patientInsurance) => {
                    
                    if (patientInsurance.hasOwnProperty('error')) {
                        ErrorService.showErrorAlert('Oops! Something went wrong. Please try again later. If the issue persists, please contact our support team for assistance.', patientInsurance);
                    }
                    resolve(patientInsurance)
            })
                .catch((e) => {
                    console.log('Patient Insurance Serice error');
                    reject(e);
                });
        });
    }
}
export default PatientInsuranceService;